import * as NavigationMenu from '@radix-ui/react-navigation-menu';

import { buttons } from '@/styles/buttons';
import { popover } from '@/styles/popover';

import { ArrowUpRightIcon } from '@/ui/Icons/ArrowUpRightIcon';
import { ChevronDownIcon } from '@/ui/Icons/ChevronDownIcon';

import { routes } from '../../../utils/routes';
import { LearnMoreDropDownList } from '../LearnMoreDropDownList';

export const FeaturesPageNavigationMenu = () => {
  const { learnMore } = popover();

  return (
    <NavigationMenu.Root>
      <NavigationMenu.List className="hidden tablet:flex gap-3 self-start -translate-x-5">
        <NavigationMenu.Item>
          <NavigationMenu.Trigger
            className={buttons({
              size: 'small',
              shape: 'rounded',
              color: 'transparent',
              class: [
                'pr-3 h-10 p-4 cursor-default text-token-gray-1600 whitespace-nowrap rounded-[40px] hover:bg-token-alphalight-200 disabled:bg-token-alphalight-200 disabled:cursor-none disabled:border-[1px] disabled:border-solid disabled:border-token-gray-300',
              ],
            })}
            onClick={(e) => {
              // nativeEvent.detail becomes `0` if the triggering event was initiated
              // by a non-pointer device
              if (e.nativeEvent.detail !== 0) {
                e.stopPropagation();
                e.preventDefault();
              }
            }}
          >
            Features
            <ChevronDownIcon className="ml-1" style={{ color: 'rgba(146, 153, 166, 1)' }} />
          </NavigationMenu.Trigger>
          <NavigationMenu.Content
            className={learnMore()}
            style={{
              position: 'absolute',
              width: '332px',
              maxWidth: '332px',
              marginLeft: '-110px',
            }}
          >
            <LearnMoreDropDownList hideBlogButton hideCompanyButton isInFeaturesPage />
          </NavigationMenu.Content>
        </NavigationMenu.Item>

        <NavigationMenu.Item>
          <NavigationMenu.Link
            className={buttons({
              size: 'small',
              shape: 'rounded',
              color: 'transparent',
              class: [
                'cursor-pointer pr-3 h-10 p-4 text-token-gray-1600 whitespace-nowrap rounded-[40px] hover:bg-token-alphalight-200 disabled:bg-token-alphalight-200 disabled:cursor-none disabled:border-[1px] disabled:border-solid disabled:border-token-gray-300',
              ],
            })}
            href={routes.ABOUT_MATCHA}
          >
            Company
          </NavigationMenu.Link>
        </NavigationMenu.Item>

        <NavigationMenu.Item>
          <NavigationMenu.Link
            target="_blank"
            className={buttons({
              size: 'small',
              shape: 'rounded',
              color: 'transparent',
              class: [
                'cursor-pointer pr-3 h-10 p-4 text-token-gray-1600 whitespace-nowrap rounded-[40px] hover:bg-token-alphalight-200 disabled:bg-token-alphalight-200 disabled:cursor-none disabled:border-[1px] disabled:border-solid disabled:border-token-gray-300',
              ],
            })}
            href={routes.BLOG}
          >
            Blog
            <ArrowUpRightIcon className="ml-1 text-token-[rgba(94, 103, 115, 1)]" aria-hidden />
          </NavigationMenu.Link>
        </NavigationMenu.Item>
      </NavigationMenu.List>
    </NavigationMenu.Root>
  );
};
